import { cache } from '@/container/apollo-client/cache';
import { JobStatusEnum } from '@/types/generated/graphql';
import { MessageBoxViewProps } from '../conversation.types';

export function updateTranscriptionStatusInCache(
  providerCallRecordingsId: number | null | undefined,
  id: number | null | undefined,
  jobStatus: JobStatusEnum | null | undefined
) {
  const recordingCacheId = cache.identify({
    __typename: 'Recording',
    id: providerCallRecordingsId,
  });

  if (!recordingCacheId) return;

  cache.modify({
    id: recordingCacheId,
    fields: {
      transcription(existing) {
        return {
          ...(existing || {}),
          id,
          jobStatus,
          __typename: 'TranscriptionInformation',
        };
      },
    },
  });
}

export function getTranscriptionRecordingId(
  callRecording?: { id?: number | string } | null,
  voicemailRecording?: { id?: number | string } | null
) {
  return callRecording?.id ?? voicemailRecording?.id ?? null;
}

export function getTranscriptionJobStatus(
  callRecording?: { transcription?: { jobStatus?: JobStatusEnum | string } } | null,
  voicemailRecording?: { transcription?: { jobStatus?: JobStatusEnum | string } } | null
) {
  const status = callRecording?.transcription?.jobStatus ?? voicemailRecording?.transcription?.jobStatus;
  if (!status) return undefined;
  if (Object.values(JobStatusEnum).includes(status as JobStatusEnum)) {
    return status as JobStatusEnum;
  }
  return undefined;
}

export function useTranscriptionState(
  callRecording: MessageBoxViewProps['callRecording'],
  voicemailRecording: MessageBoxViewProps['voicemailRecording']
) {
  const jobStatus = getTranscriptionJobStatus(callRecording, voicemailRecording);
  return {
    transcriptionId: getTranscriptionRecordingId(callRecording, voicemailRecording),
    isCompleted: jobStatus === JobStatusEnum.COMPLETED,
    isInProgress: jobStatus === JobStatusEnum.IN_PROGRESS,
  };
}
